import { getBrowserTimezone } from './getBrowserTimezone'

export const getEffectiveTimezone = (zone?: string | null) => {
  if (zone === null || zone === undefined || zone.length === 0) {
    return getBrowserTimezone()
  }

  return zone
}
